import SelectAllIcon from "@mui/icons-material/SelectAll";
import { useTheme } from "@mui/material";
import { Toolbar } from "common";
import { useEventEditorContext } from "../Editor/EventEditorContext";
export interface EditRowHeaderProps {
  time: string;
}

export default function EditRowHeader({ time }: EditRowHeaderProps) {
  const theme = useTheme();

  const {
    editMode,
    groupEditMode,
    selectSameEventsSameTime,
    selectSameGroupsSameTime,
  } = useEventEditorContext();
  function handleSelect() {
    if (groupEditMode === "event") {
      selectSameEventsSameTime(time);
    } else if (groupEditMode === "group") {
      selectSameGroupsSameTime(time);
    }
  }
  if (editMode !== "groupEdit") {
    return time as any;
  }
  return (
    <Toolbar
      onClick={evt => {
        evt.stopPropagation();
        console.log("Row action:", time);
        handleSelect();
      }}
      sx={{ cursor: "pointer" }}
    >
      {/*<Checkbox size="small" />*/}
      <SelectAllIcon fontSize="small" />
      {time}
    </Toolbar>
  );
}
